import React, { createContext, FunctionComponent, PropsWithChildren, useContext, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

export interface EsidContextProps {
  esid: string
}

const defaultContext: EsidContextProps = {
  esid: '',
}

const EsidContext = createContext<EsidContextProps>(defaultContext)

export const useEsid = (): EsidContextProps => {
  return useContext(EsidContext)
}

export const EsidProvider: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const [esid] = useState(() => `esid-${uuidv4()}`)

  return <EsidContext.Provider value={{ esid }}>{children}</EsidContext.Provider>
}
